import React, { useEffect, useState } from 'react';
import TableComponent from 'components/table-component/Table';
import Error from 'components/Error';
import { useTranslation } from 'react-i18next';
import TicketTypesHeaders from './TicketTypesHeaders';
import TicketTypeEditModal from './TicketTypeEditModal';
import { CallAPI } from 'actions/General';
import { ticketTypesHeaderList } from './utils';
import { isPermissionAvailable } from 'config/permissionUtils';
import { permissionKeys } from 'config/config';
import FormButton from 'components/form-components/FormButton';
import plusIcon from 'assets/images/icons/plus.svg';

const TicketTypes = () => {
  const { t } = useTranslation();

  const [ticketsTypes, setTicketTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inputFilters, setInputFilters] = useState({});
  const [appliedFilters, setAppliedFilters] = useState({});
  const [APIError, setAPIError] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedRecordId, setSelectedRecordId] = useState(null);

  const handleFilterChange = (name, value) => {
    setInputFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleDebouncedSearch = (name, value) => {
    setAppliedFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddTicketType = () => {
    setInputFilters({});
    setAppliedFilters({});
    setIsEditMode(false);
    setModalVisible(true);
  };

  const rowActions = (id, action) => {
    setSelectedRecordId(id);
    if (action === 'edit') {
      setIsEditMode(true);
      setModalVisible(true);
    }
  };

  const fetchTicketTypeList = async () => {
    const result = await CallAPI(
      'GET_ALL_TICKET_TYPES',
      { searchText: appliedFilters?.search ?? '' },
      null,
      setLoading,
      setAPIError,
    );
    if (result.status) {
      setTicketTypes(result.data);
    }
    setSelectedRecordId(null);
  };

  useEffect(() => {
    fetchTicketTypeList();
  }, [appliedFilters]);

  return (
    <div>
      {APIError && <Error msg={APIError} />}

      <TicketTypesHeaders
        filteringData={inputFilters}
        setFilteringData={handleFilterChange}
        debounceFunc={handleDebouncedSearch}
        handleAddTicketType={handleAddTicketType}
      />

      <TableComponent
        header={ticketTypesHeaderList.filter(
          (item) =>
            item.name !== 'edit_delete' ||
            isPermissionAvailable(permissionKeys.field_work_tickets_create),
        )}
        data={ticketsTypes}
        props={{
          translateValueFunc: (val) => t(val),
          actionsCallBack: fetchTicketTypeList,
          actionOnclick: rowActions,
        }}
        loader={loading}
        filterEnabled={false}
        isFieldSelectionEnabled={false}
        isActionsEnabled={false}
        totalRecords={0}
        isPaginationEnabled={false}
        noDataComponent={
          <div className='lh-1 w-100 d-flex flex-column gap-3 justify-content-center align-items-center'>
            <span className='theme-text-black-1 theme-size-1_3'>{t('text_empty_types')}</span>
            <span>{t('text_create_types_to_get_started')}</span>
            <FormButton
              text='button_add_type'
              variant='green-1'
              onClick={handleAddTicketType}
              icon={plusIcon}
              iconClasses='svg-white'
            />
          </div>
        }
      />

      {modalVisible && (
        <TicketTypeEditModal
          editMode={isEditMode}
          handleClose={() => setModalVisible(false)}
          refreshList={fetchTicketTypeList}
          selectedRecordId={selectedRecordId}
        />
      )}
    </div>
  );
};

export default TicketTypes;
